import API from "../api";

export async function globalSearch(q) {
    const { data } = await API.get("/search", { params: { q } });
    return data || { students: [], coaches: [], batches: [] };
}
